import React from 'react';
import Snack from './snack'
import { throttle } from 'underscore';

export interface SnackData {
  uid: string;
  type: string;
  title?: string;
  text?: string;
  timeout?: number | boolean;
}

export interface SnackbarProps {
  snacks: SnackData[],
  deleteSnack: (uid: string) => void;
}

export interface SnackbarState {
  actives: Set<string>;
  removes: Set<string>;
}


class Snackbar extends React.Component<SnackbarProps, SnackbarState> {

  state: SnackbarState;
  el: HTMLElement | undefined;
  elPosTop: number | undefined;

  constructor(props:SnackbarProps) {
    super(props);

    this.state = {
      actives: new Set(),
      removes: new Set(),
    };

    this.dismissSnack = this.dismissSnack.bind(this);
  }


  componentDidMount() {
    this.el = document.getElementById('VetappSnackbar') || undefined;
    this.elPosTop = this.el?.getBoundingClientRect().top;

    const listener = throttle(this.setPosition, 1000 / 30);

    // add the listener to positon the snackbar
    window.addEventListener('scroll', listener);
    window.addEventListener('resize', listener);
    window.addEventListener('orientationchange', listener);

    // call once for inital positioning
    this.setPosition();
  }


  componentDidUpdate() {
    // are any of the snacks new?
    const newSnacks = this.props.snacks.filter(s => !this.state.actives.has(s.uid));

    if (newSnacks.length) {
      const actives = new Set(this.state.actives);
      newSnacks.forEach(s => actives.add(s.uid));

      window.setTimeout(() => {
        this.setState({
          actives: actives,
        })
      }, 100);
    }
  }


  render() {

    return (
      <div className="Snackbar" id="VetappSnackbar">
        <div className="snacks">
          {this.props.snacks.map(s => 
            <Snack active={this.state.actives.has(s.uid)} removed={this.state.removes.has(s.uid)} 
              { ...s } 
              dismiss={this.dismissSnack} key={s.uid} />
          )}
        </div>
      </div>
    );
  }


  dismissSnack(uid: string) {
    // add the snack to the removes list
    const removes = new Set(this.state.removes);
    removes.add(uid);

    this.setState({
      removes,
    });

    // after granting time for css transition, remove the snack entirely
    window.setTimeout(() => {
      const actives = new Set(this.state.actives);
      const removes = new Set(this.state.removes);
      actives.delete(uid);
      removes.delete(uid);

      this.props.deleteSnack(uid);

      this.setState({
        actives,
        removes,
      });
    }, 1000);
  }


  // stick the snackbar to the bottom of the window
  setPosition = () => {
    if (!this.el || this.elPosTop === undefined) return;

    const wbottom = window.scrollY + window.innerHeight;

    this.el.style.top = (wbottom - (this.elPosTop)) + "px";
  }

}


export default Snackbar;
